module.exports = __webpack_public_path__ + "img/clock-regular.d7a97a7a.svg";